module.exports = __webpack_public_path__ + "img/cv-template-12.cb7950fb.png";